export const VIDEO_PLAYER_SELECTOR = '.video-player';
export const VIDEO_PLAYER_BTN = 'button[data-click="togglePlayer"]';
export const VIDEO_PLAYER_IMG_WRAPPER_SELECTOR = '.video-player__img-wrapper';
export const VIDEO_PLAYER_FRAME_SELECTOR = '.video-player__player';
export const VIDEO_PLAYER_FRAME_WRAPPER_SELECTOR = '.video-player__player-wrapper';

/**
 * Event handler for show player button click
 * @param {HTMLElement} section - The section DOM Element
 */
export function _init(section) {
    const toggleBtn = section.querySelector(VIDEO_PLAYER_BTN);
    const imgWrapper = section.querySelector(VIDEO_PLAYER_IMG_WRAPPER_SELECTOR);
    const frameWrapper = section.querySelector(VIDEO_PLAYER_FRAME_WRAPPER_SELECTOR);
    const frame = section.querySelector(VIDEO_PLAYER_FRAME_SELECTOR);
    let frameUrl = frame ? frame.getAttribute('src') : null;
    
    if (toggleBtn && imgWrapper) {
        toggleBtn.addEventListener('click', function () {
            imgWrapper.setAttribute('style', 'display:none;');
            
            if (frameUrl) {
                const newFrameURL = `${frameUrl}&autoplay=1`;
                frame.setAttribute('src', newFrameURL);
            }
            frameWrapper.removeAttribute('style');
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(VIDEO_PLAYER_SELECTOR).forEach(section => {
        _init(section);
    });
});